module.exports = __webpack_public_path__ + "img/log.d94ace6f.svg";